import { render, staticRenderFns } from "./card-briefing-project.vue?vue&type=template&id=329d7342&"
import script from "./card-briefing-project.vue?vue&type=script&lang=js&"
export * from "./card-briefing-project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports